// extracted by mini-css-extract-plugin
module.exports = {"link":"_3lfWv","clickable":"_36KJs","svgRoot":"_36XXs","nonScalingStroke":"_3Qjwl","hasShadow":"_1Bfd6","hasStroke":"nNg5w"};